var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurgerCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.414,
    height: 13.414,
    viewBox: "0 0 13.414 13.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "burger",
    transform: "translate(-32.793 -32.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(2 -1)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Ligne_57",
    "data-name": "Ligne 57",
    x2: 12,
    y2: 12,
    transform: "translate(31.5 34.5)",
    fill: "none",
    stroke: "#1f39ca",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_69",
    "data-name": "Ligne 69",
    x1: 12,
    y2: 12,
    transform: "translate(31.5 34.5)",
    fill: "none",
    stroke: "#1f39ca",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerCross);
export default __webpack_public_path__ + "static/media/burgerCross.fad947e868b6780a2107d24a22df9f92.svg";
export { ForwardRef as ReactComponent };